import React, { FC } from 'react';
// mui components
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  RadioProps,
  RadioGroupProps,
} from '@mui/material';
// styles
import { radioStyles } from './styles';

interface IOption {
  label: string | number;
  value: string | number;
  subLabel?: string;
}

export interface ICustomRadioProps {
  label?: string;
  selectedOption: string | number;
  options: IOption[];
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  radioProps?: RadioProps;
  radioGroupProps?: RadioGroupProps;
  customStyles?: any;
}

const CustomRadio: FC<ICustomRadioProps> = ({
  options,
  selectedOption,
  handleChange,
  label,
  customStyles,
  radioProps = {},
  radioGroupProps = {},
}) => {
  const styles = !!customStyles ? customStyles : radioStyles.label;

  return (
    <>
      {label && <FormLabel sx={radioStyles.formLabel}>{label}</FormLabel>}
      <RadioGroup
        sx={radioStyles.radio}
        value={selectedOption}
        onChange={handleChange}
        {...radioGroupProps}
      >
        {options.map((item) => (
          <>
            <FormControlLabel
              key={item.value}
              value={item.value}
              control={<Radio disableRipple {...radioProps} />}
              label={item.label}
              sx={styles}
            />

            {item.subLabel && <FormLabel sx={radioStyles.itemLabel}>{item.subLabel}</FormLabel>}
          </>
        ))}
      </RadioGroup>
    </>
  );
};

export default CustomRadio;
